module.exports = __webpack_public_path__ + "img/gallery_on.501ffc92.png";